<div class="row grid-row">
    <div class="col-md-2 col-sm-2 grid-column" hznTestId="enrollment-report-row-member-id">{{item.memberId}}</div>
    <div class="col-md-3 col-sm-3 grid-column">{{item.finalizedBy}}</div>
    <div class="col-md-3 col-sm-3 grid-column" hznTestId="enrollment-report-row-child">{{item.childFullName}}</div>
    <div class="col-md-2 col-sm-2 grid-column" hznTestId="enrollment-report-row-club">{{item.clubCode}}</div>
    <div class="col-md-2 col-sm-2 grid-column">{{item.purchaseSetNumber}}</div>
</div>